import { SelectableComorbidities } from "../Utility/Constants";

export const getGeneralPrescriptionDataJson = () => {
  return {
    weight : "",
    bloodPressure: "",
    temprature: "",
    bloodSugar: "",
    complaint: "",
    comorbidities: SelectableComorbidities.map((c) => ({ ...c, selected: false })),
    comorbiditiesNotes: "",
    medicalAndSurgicalHistory: "",
    diagnosis: "",
    medicines: [],
    tests: [],
    additionalNotes: "",
    followupDate: "",
  };
};